import { useFeatureFlagClient } from '@/composables/featureFlags.js'
import { useAuth } from '@/composables/useAuth.js'
import { isSamePage } from '@/utils/middleware.js'
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (isSamePage(to, from)) {
    return
  }

  const {
    fetchCurrentUser,
    fetchAvailableDepartments,
    fetchNavigationSidebar,
    fetchMergedSettings,
    fetchCurrentOrganization,
    fetchActivePermissions,
    isLoggedIn,
  } = useAuth()
  const config = useRuntimeConfig()

  // skip on '/init' when in test mode (used in fixtures.ts)
  if (to.path === '/init' && config.public.isTest) {
    return
  }

  // we need a provetId to continue
  if (!to.params.provetId) {
    return
  }

  // no need to re-fetch
  if (isLoggedIn.value) {
    return
  }

  await Promise.all([
    fetchCurrentUser(to),
    fetchAvailableDepartments(to),
    fetchNavigationSidebar(to),
    fetchMergedSettings(to),
    fetchCurrentOrganization(to),
    fetchActivePermissions(to),
  ])

  // Explicitly re-identify with LaunchDarkly now that we have auth context (including activeDepartment)
  // This ensures flags and guards see the correct context before the page renders.
  try {
    const featureFlagClient = useFeatureFlagClient(to)
    await featureFlagClient?.updateLaunchDarklyContext()
  } catch {
    // Don't block navigation if update fails; page should still render with original context.
  }
})
